import { Controller, FieldPath, FieldValues, useFormContext } from 'react-hook-form';

import {
  CustomRadioFieldGroup,
  CustomRadioFieldGroupProps,
} from '@/components/shared/components/NewContextForms/shared/CustomRadioFieldGroup';

export interface RadioFromFieldGroupProps<TFieldValues extends FieldValues>
  extends CustomRadioFieldGroupProps<TFieldValues> {
  name: FieldPath<TFieldValues>;
  dummyField?: boolean;
}

export function RadioFromFieldGroup<T extends FieldValues>({
  name,
  dummyField = false,
  ...props
}: RadioFromFieldGroupProps<T>) {
  const formControl = useFormContext()?.control;

  if (!formControl || dummyField) return <CustomRadioFieldGroup disabled={true} {...props} />;

  return (
    <Controller
      name={name}
      control={formControl}
      render={({ field, fieldState: { error } }) => (
        <CustomRadioFieldGroup field={field} error={error} disabled={dummyField} {...props} />
      )}
    />
  );
}
